/* eslint-disable @typescript-eslint/indent */

import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import * as moment from "moment";
import { FORMAT } from "../constants/formats";

export function isBetweenValidator(
  minDate: moment.MomentInput,
  maxDate: moment.MomentInput,
  inclusivity: "()" | "[)" | "(]" | "[]" = "[]",
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value && !moment.isMoment(moment(control.value, true))) {
      return { invalidDate: "Date not valid" };
    }

    return moment(control.value).isBetween(minDate, maxDate, undefined, inclusivity)
      ? null
      : {
          invalidDate: `The date must be between ${moment(minDate).format(FORMAT.DATE)} and ${moment(maxDate).format(
            FORMAT.DATE,
          )}`,
        };
  };
}
